<script>
  import solicitacaoCompraServico from '../../servico';

  export default {
    props: {
      mostrar: {
        type: Boolean,
        required: true,
      },
      id: {
        required: true,
      },
    },
    data() {
      return {
        configuracao: this.$storage.configuracao(),
        carregando: false,
        historico: null,
      }
    },
    computed: {
      fusp() {
        return this.configuracao.abreviaturaFundacao.toUpperCase() === 'FUSP';
      },
      possuiHistorico() {
        return !!this.historico && this.historico.itens.length > 0;
      },
    },
    watch: {
      mostrar(valor) {
        if (valor) {
          this.carregar();
          return;
        }

        this.historico = null;
      },
    },
    methods: {
      carregar() {
        if (!this.fusp || !this.id) return;

        this.carregando = true;

        solicitacaoCompraServico
          .historico(this.id)
          .then(resultado => {
            this.historico = resultado;
            this.carregando = false;
          })
          .catch(() => {
            this.historico = null;
            this.carregando = false;
          });
      },
    },
  }
</script>

<template>
  <div v-if="fusp">
    <div v-if="carregando" class="text-center">
      <i class="fa fa-spinner fa-pulse"></i> Carregando histórico...
    </div>

    <div v-if="!carregando && possuiHistorico">
      <hr/>

      <h4>Histórico solicitação compra</h4>

      <div class="row">
        <dl class="col-xs-4">
          <dt>Duração total status</dt>
          <dd>{{ historico.duracaoTotalStatus }}</dd>
        </dl>
        <dl class="col-xs-4">
          <dt>Tempo total em aberto</dt>
          <dd>{{ historico.tempoTotalEmAberto }}</dd>
        </dl>
      </div>

      <div class="table-responsive">
        <table class="table table-bordered">
          <thead>
          <tr>
            <th>Data e hora</th>
            <th>Duração entre status</th>
            <th>Usuário</th>
            <th>Status</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item, index) in historico.itens">
            <td>{{ item.dataHora | formatarData }} {{ item.dataHora | formatarHora }}</td>
            <td>{{ item.duracao || '---' }}</td>
            <td>{{ item.usuario || '---' }}</td>
            <td>{{ item.status || '---' }}</td>
          </tr>
          </tbody>
        </table>
      </div>

      <small>* Duração entre status &rarr; Tempo decorrido entre o status observado e o status anterior</small>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/solicitacao-compra/componentes/compartilhado/HistoricoSolicitacaoCompra.vue